module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-16.443a8840.png";